import { INPUT_CLASS, LABEL_CLASS, NodeViewSettingsPanel } from '@/components/common/node-view-settings-panel';
import { CommonNodeViewWrapper } from '@/components/common/node-view-wrapper';
import { useIsEditorReadonly } from '@/hooks/use-is-editor-readonly';
import type { ReactNodeViewProps } from '@tiptap/react';
import { memo } from 'react';

const IframeNodeView: React.FC<ReactNodeViewProps> = ({ node, updateAttributes, selected, decorations, editor }) => {
    const isEditorReadonly = useIsEditorReadonly(editor);
    const src = node.attrs.src ?? '';
    const width = node.attrs.width ?? '';
    const height = node.attrs.height ?? '';

    const handleSrcChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        updateAttributes({ src: e.target.value || null });
    };

    return (
        <CommonNodeViewWrapper
            decorations={decorations}
            label="Iframe"
            selected={selected}
            settingsPanel={
                <NodeViewSettingsPanel
                    fields={[
                        {
                            label: 'Source',
                            type: 'text',
                            value: src,
                            onChange: handleSrcChange,
                            placeholder: 'Enter URL...',
                            searchAttr: 'src',
                        },
                    ]}
                />
            }
            footer={
                <div className="flex items-center gap-4 border-t border-gray-200 p-2 dark:border-gray-700">
                    <div className="flex items-center gap-2">
                        <label className={LABEL_CLASS}>Width:</label>
                        <input
                            type="number"
                            value={width}
                            onChange={e => updateAttributes({ width: e.target.value || undefined })}
                            disabled={isEditorReadonly}
                            placeholder="e.g. 640"
                            inputMode="numeric"
                            className={INPUT_CLASS}
                        />
                    </div>
                    <div className="flex items-center gap-2">
                        <label className={LABEL_CLASS}>Height:</label>
                        <input
                            type="number"
                            value={height}
                            onChange={e => updateAttributes({ height: e.target.value || undefined })}
                            disabled={isEditorReadonly}
                            placeholder="e.g. 360"
                            inputMode="numeric"
                            className={INPUT_CLASS}
                        />
                    </div>
                </div>
            }
        >
            {src ? (
                <div
                    className="border-t border-gray-200 p-4 dark:border-gray-700"
                    contentEditable={false}
                >
                    <iframe
                        src={src}
                        title="Embedded content"
                        width={width || undefined}
                        height={height || undefined}
                        className="max-w-full rounded border border-gray-200 dark:border-gray-700"
                    />
                </div>
            ) : (
                <div
                    className="border-t border-gray-200 px-4 py-8 text-center text-sm text-gray-500 dark:border-gray-700 dark:text-gray-400"
                    contentEditable={false}
                >
                    Enter a URL above to preview the iframe.
                </div>
            )}
        </CommonNodeViewWrapper>
    );
};

export default memo(IframeNodeView);
